import { BarChart } from "@/components/analytics/bar-chart";
import { ChartPanel } from "@/components/analytics/chart-panel";
import type { FeatureImportanceResponse } from "./queries";

interface FeatureImportanceProps {
  data: FeatureImportanceResponse;
}

export function FeatureImportance({ data }: FeatureImportanceProps) {
  const features = data.feature_importance ?? [];
  const sorted = [...features].sort((a, b) => b.importance - a.importance).slice(0, 20);

  if (sorted.length === 0) {
    return (
      <ChartPanel title="Feature Importance" subtitle="No feature importance data available">
        <div className="flex h-[300px] items-center justify-center text-sm text-muted">
          No features found
        </div>
      </ChartPanel>
    );
  }

  // Cast to Record<string, unknown>[] for BarChart
  const chartData: Array<Record<string, unknown>> = sorted.map((item) => ({
    feature: item.feature,
    importance: item.importance,
    p_value: item.p_value,
  }));

  return (
    <ChartPanel
      title="Feature Importance"
      subtitle={`Top ${sorted.length} features by SHAP importance`}
    >
      <BarChart
        data={chartData}
        dataKey="importance"
        nameKey="feature"
        layout="vertical"
        height={Math.max(300, sorted.length * 25)}
      />
    </ChartPanel>
  );
}
